import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Internet memestalgia",
  "description": "",
  "published": "2009-06-11T00:00:00.000Z",
  "redirect_from": ["/blog/internet-memestalgia/swizec/592"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Been listening to the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Llama",
        "title": "Llama"
      }}>{`llama`}</a>{` song a lot lately and was reminded of all the brilliant `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Meme",
        "title": "Meme"
      }}>{`memes`}</a>{` that existed on the internets long before there was youtube or anything like web2.0. It was quite a different time in our lives and accordingly the humor was much different as well.`}</p>
    <p>{`Enjoy these old classics, do hope you still remember them.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/421cb74e-e79f-4d65-b005-67750ae98be1/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=421cb74e-e79f-4d65-b005-67750ae98be1",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      